import React, { useState } from "react";
import { useTranslation } from "../../i18n/hooks/useTranslation";
import FilterStyled from "./FilterStyled";

interface FilterProps {
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
}

const Filter: React.FC<FilterProps> = ({ value, onChange }): JSX.Element => {
  const { t } = useTranslation();
  const [mainCategory, setMainCategory] = useState<string>("");
  const [subCategory, setSubCategory] = useState<string>("");

  const handleMainCategoryChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setMainCategory(event.target.value);
    await onChange(event);
    setSubCategory("");
  };

  const handleSubCategoryChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSubCategory(event.target.value);
    onChange(event);
  };

  const renderSubCategoryOptions = () => {
    switch (mainCategory) {
      case "aigua":
        return (
          <>
            <option value="aljubs i pous">
              {t("filters.subcategories.water.wells")}
            </option>
            <option value="altres">
              {t("filters.subcategories.water.others")}
            </option>
            <option value="basses">
              {t("filters.subcategories.water.ponds")}
            </option>
            <option value="cisternes">
              {t("filters.subcategories.water.cisterns")}
            </option>
            <option value="fonts">
              {t("filters.subcategories.water.springs")}
            </option>
          </>
        );
      case "construccions":
        return (
          <>
            <option value="arnere i calatxos">
              {t("filters.subcategories.constructions.dryStone")}
            </option>
            <option value="balmes i canyons">
              {t("filters.subcategories.constructions.caves")}
            </option>
            <option value="camins i carrerades">
              {t("filters.subcategories.constructions.paths")}
            </option>
            <option value="conjunts agricoles">
              {t("filters.subcategories.constructions.agricultural")}
            </option>
            <option value="edificis">
              {t("filters.subcategories.constructions.buildings")}
            </option>
            <option value="forns">
              {t("filters.subcategories.constructions.ovens")}
            </option>
            <option value="massos">
              {t("filters.subcategories.constructions.farms")}
            </option>
          </>
        );
      case "territori":
        return (
          <>
            <option value="bosc i arbres">
              {t("filters.subcategories.territory.forest")}
            </option>
            <option value="cims colls">
              {t("filters.subcategories.territory.peaks")}
            </option>
            <option value="llocs d'intères">
              {t("filters.subcategories.territory.points")}
            </option>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <FilterStyled>
      <div className="filter__container">
        <select
          className="filter__select"
          onChange={handleMainCategoryChange}
          value={mainCategory}
          id="mainCategory"
          name="categories"
          required
        >
          <option value="">{t("filters.all")}</option>
          <option value="aigua">{t("filters.categories.water")}</option>
          <option value="construccions">
            {t("filters.categories.constructions")}
          </option>
          <option value="territori">{t("filters.categories.territory")}</option>
        </select>

        {mainCategory && (
          <select
            className="filter__select"
            onChange={handleSubCategoryChange}
            value={subCategory}
            id="subCategory"
            name="subcategories"
            placeholder={t("filters.subcategory")}
            required
          >
            <option value="">{t("filters.all")}</option>
            {renderSubCategoryOptions()}
          </select>
        )}
      </div>
    </FilterStyled>
  );
};

export default Filter;
